import { DefaultNameList, DefaultNameShow, DefaultNameCreate, DefaultNameEdit } from './Simple';

export default {
    list: DefaultNameList,
    show: DefaultNameShow,
    edit: DefaultNameEdit,
    create: DefaultNameCreate
};
